

class AuthService {
    

    logOut() {
        // localStorage.removeItem(localStorageKey);
        // localStorage.removeItem(tokenExpiryKey);
        localStorage.removeItem('userInfo');

        this.idToken = null;
        this.tokenExpiry = null;
        this.profile = null;

        // webAuth.logout({
        //     returnTo: window.location.origin + process.env.BASE_URL
        // });

        // this.emit(loginEvent, { loggedIn: false });
    }

    isAuthenticated() {
        return (
            localStorage.getItem('sessionToken')  &&
            localStorage.getItem('sessionToken') !== null
        );
    }
}

export default new AuthService();
